import React from 'react';
import styles from './RematchRequestModal.module.css';
import { useLanguage } from '../Providers/LanguageContext';

interface RematchRequestModalProps {
  isOpen: boolean;
  opponentUsername: string;
  onAccept: () => void;
  onDecline: () => void;
}

export default function RematchRequestModal({
  isOpen,
  opponentUsername,
  onAccept,
  onDecline
}: RematchRequestModalProps) {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.icon}>
          <span>&#x21bb;</span>
        </div>
        <h2 className={styles.title}>{t('multiplayer.rematchRequest')}</h2>
        <p className={styles.message}>
          <strong>{opponentUsername}</strong> {t('multiplayer.rematchMessage', { opponent: '' }).replace('{opponent}', '').trim()}
        </p>
        <div className={styles.actions}>
          <button className={styles.acceptButton} onClick={onAccept}>
            {t('common.accept')}
          </button>
          <button className={styles.declineButton} onClick={onDecline}>
            {t('common.decline')}
          </button>
        </div>
      </div>
    </div>
  );
}
